"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var WorkspaceSelection = (function () {
    function WorkspaceSelection() {
    }
    return WorkspaceSelection;
}());
exports.WorkspaceSelection = WorkspaceSelection;
var SingleCell = (function (_super) {
    __extends(SingleCell, _super);
    function SingleCell(cell) {
        var _this = _super.call(this) || this;
        _this.cell = cell;
        return _this;
    }
    SingleCell.prototype.containsCell = function (cell) {
        return cell.i === this.cell.i && cell.j === this.cell.j;
    };
    SingleCell.prototype.enumerateCells = function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, this.cell];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    };
    return SingleCell;
}(WorkspaceSelection));
exports.SingleCell = SingleCell;
var NoSelection = (function (_super) {
    __extends(NoSelection, _super);
    function NoSelection() {
        return _super.call(this) || this;
    }
    NoSelection.prototype.containsCell = function (cell) {
        return false;
    };
    NoSelection.prototype.enumerateCells = function () { return __generator(this, function (_a) {
        return [2];
    }); };
    NoSelection.instance = new NoSelection();
    return NoSelection;
}(WorkspaceSelection));
exports.NoSelection = NoSelection;
var RangeSelection = (function (_super) {
    __extends(RangeSelection, _super);
    function RangeSelection(start, end, inclusive) {
        if (inclusive === void 0) { inclusive = true; }
        var _this = _super.call(this) || this;
        _this.start = start;
        _this.end = end;
        _this.inclusive = inclusive;
        var maxI = Math.max(_this.start.i, _this.end.i);
        var minI = Math.min(_this.start.i, _this.end.i);
        var maxJ = Math.max(_this.start.j, _this.end.j);
        var minJ = Math.min(_this.start.j, _this.end.j);
        _this.bounds = {
            min: { i: minI, j: minJ },
            max: { i: maxI, j: maxJ }
        };
        return _this;
    }
    RangeSelection.prototype.getBounds = function () {
        return this.bounds;
    };
    RangeSelection.prototype.containsCell = function (cell) {
        if (!this.inclusive && this.start.i === cell.i && this.start.j === cell.j) {
            return false;
        }
        return this.bounds.min.i <= cell.i && cell.i <= this.bounds.max.i
            && this.bounds.min.j <= cell.j && cell.j <= this.bounds.max.j;
    };
    RangeSelection.prototype.enumerateCells = function () {
        var i, j;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    i = this.bounds.min.i;
                    _a.label = 1;
                case 1:
                    if (!(i <= this.bounds.max.i)) return [3, 6];
                    j = this.bounds.min.j;
                    _a.label = 2;
                case 2:
                    if (!(j <= this.bounds.max.j)) return [3, 5];
                    if (!this.inclusive && this.start.i === i && this.start.j === j) {
                        return [3, 4];
                    }
                    return [4, { i: i, j: j }];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    j++;
                    return [3, 2];
                case 5:
                    i++;
                    return [3, 1];
                case 6: return [2];
            }
        });
    };
    RangeSelection.prototype.changeEnd = function (cell) {
        return new RangeSelection(this.start, cell);
    };
    return RangeSelection;
}(WorkspaceSelection));
exports.RangeSelection = RangeSelection;
var CompositeSelection = (function (_super) {
    __extends(CompositeSelection, _super);
    function CompositeSelection(added, subtracted) {
        var _this = _super.call(this) || this;
        _this.added = added;
        _this.subtracted = subtracted;
        return _this;
    }
    CompositeSelection.prototype.containsCell = function (cell) {
        var inclusionCount = this.added.reduce(function (count, selection) {
            return count + (selection.containsCell(cell) ? 1 : 0);
        }, 0) - this.subtracted.reduce(function (count, selection) {
            return count + (selection.containsCell(cell) ? 1 : 0);
        }, 0);
        return inclusionCount > 0;
    };
    CompositeSelection.prototype.getAddedSelections = function () {
        return this.added;
    };
    CompositeSelection.prototype.getSubtractedSelections = function () {
        return this.subtracted;
    };
    CompositeSelection.prototype.enumerateCells = function () {
        var cellCount, _a, _b, add, _c, _d, cell, row, _e, _f, remove, _g, _h, cell, row, _j, _k, i, _l, _m, j, e_1_1, e_2_1;
        var e_3, _o, e_4, _p, e_5, _q, e_6, _r, e_2, _s, e_1, _t;
        return __generator(this, function (_u) {
            switch (_u.label) {
                case 0:
                    cellCount = {};
                    try {
                        for (_a = __values(this.added), _b = _a.next(); !_b.done; _b = _a.next()) {
                            add = _b.value;
                            try {
                                for (_c = (e_4 = void 0, __values(add.enumerateCells())), _d = _c.next(); !_d.done; _d = _c.next()) {
                                    cell = _d.value;
                                    row = cellCount[cell.i];
                                    if (!row) {
                                        cellCount[cell.i] = row = {};
                                    }
                                    if (!row[cell.j]) {
                                        row[cell.j] = 1;
                                    }
                                    else {
                                        row[cell.j]++;
                                    }
                                }
                            }
                            catch (e_4_1) { e_4 = { error: e_4_1 }; }
                            finally {
                                try {
                                    if (_d && !_d.done && (_p = _c.return)) _p.call(_c);
                                }
                                finally { if (e_4) throw e_4.error; }
                            }
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (_b && !_b.done && (_o = _a.return)) _o.call(_a);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                    try {
                        for (_e = __values(this.subtracted), _f = _e.next(); !_f.done; _f = _e.next()) {
                            remove = _f.value;
                            try {
                                for (_g = (e_6 = void 0, __values(remove.enumerateCells())), _h = _g.next(); !_h.done; _h = _g.next()) {
                                    cell = _h.value;
                                    row = cellCount[cell.i];
                                    if (!row) {
                                        cellCount[cell.i] = row = [];
                                    }
                                    if (!row[cell.j]) {
                                        row[cell.j] = -1;
                                    }
                                    else {
                                        row[cell.j]--;
                                    }
                                }
                            }
                            catch (e_6_1) { e_6 = { error: e_6_1 }; }
                            finally {
                                try {
                                    if (_h && !_h.done && (_r = _g.return)) _r.call(_g);
                                }
                                finally { if (e_6) throw e_6.error; }
                            }
                        }
                    }
                    catch (e_5_1) { e_5 = { error: e_5_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_q = _e.return)) _q.call(_e);
                        }
                        finally { if (e_5) throw e_5.error; }
                    }
                    _u.label = 1;
                case 1:
                    _u.trys.push([1, 12, 13, 14]);
                    _j = __values(Object.keys(cellCount)), _k = _j.next();
                    _u.label = 2;
                case 2:
                    if (!!_k.done) return [3, 11];
                    i = _k.value;
                    _u.label = 3;
                case 3:
                    _u.trys.push([3, 8, 9, 10]);
                    _l = (e_1 = void 0, __values(Object.keys(cellCount[i]))), _m = _l.next();
                    _u.label = 4;
                case 4:
                    if (!!_m.done) return [3, 7];
                    j = _m.value;
                    if (!(cellCount[i][j] > 0)) return [3, 6];
                    return [4, { i: Number(i), j: Number(j) }];
                case 5:
                    _u.sent();
                    _u.label = 6;
                case 6:
                    _m = _l.next();
                    return [3, 4];
                case 7: return [3, 10];
                case 8:
                    e_1_1 = _u.sent();
                    e_1 = { error: e_1_1 };
                    return [3, 10];
                case 9:
                    try {
                        if (_m && !_m.done && (_t = _l.return)) _t.call(_l);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7];
                case 10:
                    _k = _j.next();
                    return [3, 2];
                case 11: return [3, 14];
                case 12:
                    e_2_1 = _u.sent();
                    e_2 = { error: e_2_1 };
                    return [3, 14];
                case 13:
                    try {
                        if (_k && !_k.done && (_s = _j.return)) _s.call(_j);
                    }
                    finally { if (e_2) throw e_2.error; }
                    return [7];
                case 14: return [2];
            }
        });
    };
    CompositeSelection.prototype.addSelection = function (selection) {
        return new CompositeSelection(__spread(this.added, [selection]), this.subtracted);
    };
    CompositeSelection.prototype.subtractSelection = function (selection) {
        return new CompositeSelection(this.added, __spread(this.subtracted, [selection]));
    };
    CompositeSelection.prototype.isContiguous = function () {
        var e_7, _a;
        var _this = this;
        var contiguousChildCount = 0;
        try {
            for (var _b = __values(this.added), _c = _b.next(); !_c.done; _c = _b.next()) {
                var add = _c.value;
                if (add.addSelection && !add.isContiguous()) {
                    if (Array.from(add.enumerateCells()).some(function (p) { return _this.containsCell(p); })) {
                        return false;
                    }
                }
                else if (!!add.enumerateCells().next().value) {
                    contiguousChildCount += Array.from(add.enumerateCells()).every(function (p) { return _this.containsCell(p); }) ? 1 : 0;
                }
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_7) throw e_7.error; }
        }
        return contiguousChildCount < 2;
    };
    return CompositeSelection;
}(WorkspaceSelection));
exports.CompositeSelection = CompositeSelection;
